function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

function clearDataAndLogout(keycloak) {
  removeTokenLocalStorage()
  keycloak.clearToken()
  keycloak.logout()
}

function storeTokenLocalStorage(keycloak) {
  localStorage.setItem('token', keycloak.token)
  localStorage.setItem('kc_refreshToken', keycloak.refreshToken)
}

function removeTokenLocalStorage() {
  localStorage.removeItem('token')
  localStorage.removeItem('kc_refreshToken')
}

function updateTokenInformation(keycloak, store) {
  const payloadToken = parseJwt(keycloak.token)
  store.commit('UPDATE_KEYCLOAK', keycloak)
  store.commit('SET_USER_TOKEN_INFORMATION', payloadToken)
  store.dispatch('getUserOptions', payloadToken.preferred_username)
}

export function authenticatedKeycloak(keycloak, store) {
  if (keycloak.authenticated) {
    // When Keycloak refresh the token,
    // Store the token on the local storage
    keycloak.onAuthRefreshSuccess = () => {
      storeTokenLocalStorage(keycloak)
      updateTokenInformation(keycloak, store)
    }

    // When Keycloak try to refresh the token but failed,
    // Remove the token on the local storage and logout
    keycloak.onAuthRefreshError = () => {
      clearDataAndLogout(keycloak)
    }

    storeTokenLocalStorage(keycloak)
    updateTokenInformation(keycloak, store)
  } else {
    removeTokenLocalStorage()
  }
}
